import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { saveVisitor } from '../../Apis/content';


export const SaveVisit = createAsyncThunk('visitorrrr', async (formData, { rejectWithValue }) => {
    try {
        const response = await saveVisitor(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const headSlice = createSlice({
    name: 'head',
    initialState: {
        error: null,
        success: false,
    },
    reducers: {
        clearHeadStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(SaveVisit.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(SaveVisit.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(SaveVisit.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearHeadStatus } = headSlice.actions;
export default headSlice.reducer;

